var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5001 2.40001V6.00001C15.5001 6.66275 16.0373 7.20001 16.7001 7.20001H20.3001M8.90008 18V13.2M12.5001 18L12.5001 8.40001M16.1001 18V13.2M18.5001 4.20001C17.966 3.72215 17.4118 3.15539 17.0619 2.78729C16.8291 2.54234 16.5074 2.40001 16.1695 2.40001H7.0998C5.77432 2.40001 4.69981 3.47452 4.6998 4.8L4.69971 19.1999C4.6997 20.5254 5.77421 21.6 7.0997 21.6L17.8997 21.6C19.2252 21.6 20.2997 20.5255 20.2998 19.2001L20.3001 6.47784C20.3001 6.171 20.183 5.87604 19.9701 5.65514C19.5763 5.24666 18.9187 4.57453 18.5001 4.20001Z",
    stroke: "#434343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReport);
export default __webpack_public_path__ + "static/media/viewReport.9fd5c3b90dc871be1fb750a7f1617967.svg";
export { ForwardRef as ReactComponent };